import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import OrderList from './OrderList'

const OrderInfos = ({ orders }) => {
    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Type</TableCell>
                        <TableCell>NO</TableCell>
                        <TableCell></TableCell>
                        <TableCell>PO</TableCell>
                        <TableCell>Invoice No</TableCell>
                        <TableCell>Shipping</TableCell>
                        <TableCell>Agent</TableCell>
                        <TableCell>Customer</TableCell>
                        <TableCell>Company</TableCell>
                        <TableCell style={{ width: '50px' }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {orders?.map((order) => (
                        <OrderList order={order} key={order.id} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default OrderInfos
